import { get as $get } from './core/fetch';


export const list_items = (item_type) => $get(`/list-items/${item_type}`);
export const get_columns = (lang) => $get(`/columns/${lang}`);
export const get_break_columns = (lang) => $get(`/break-columns/${lang}`);
